import React from "react";
import ProSourceForm from "../../components/ProSourceForm";
import { Form, Row, Col, Button } from "react-bootstrap";
import { FormItem, InfoAlertHelper } from "../../components/Base";
import { GetSubmitClassList } from "../../helpers";
import { ITEM_DESCRIPTION_CHAR_LIMIT, DANGER_COLOR } from "../../constants";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { isUndefined, isNull } from "lodash";

const MySwal = withReactContent(Swal);

export default class ExtrasForm extends ProSourceForm {
  constructor(props) {
    super(props);
    const { item = {} } = this.props,
      {
        name = "",
        _id = "",
        description = "",
        minimum_number = 0,
        isRequired = false,
        maximum_number = 1,
        group_selections = [],
        store,
        brand,
      } = item;

    const formattedGroupSelections = (group_selections || []).map(
      (entry, idx) => ({
        _id:
          entry._id ||
          entry.extra_id?._id ||
          `extra_existing_${idx}_${Date.now()}`,
        ...entry,
        extra_id: {
          name: "",
          price: "",
          available: true,
          ...(entry.extra_id || {}),
        },
      }),
    );

    this.state = {
      values: {
        name,
        _id,
        minimum_number,
        maximum_number,
        isRequired,
        store,
        brand,
        description,
      },
      errors: {},
      touched: {},
      isSubmitting: false,
      file: null,
      group_selections: formattedGroupSelections,
    };

    this.validate = {
      required: ["name", "minimum_number", "maximum_number", "description"],
    };

    this.afterSubmit = this.afterSubmit.bind(this);
    this.handleOnClickCancelBtn = this.handleOnClickCancelBtn.bind(this);
    this.handleOnBlurCategory = this.handleOnBlurCategory.bind(this);
    this.onClickExtraDelete = this.onClickExtraDelete.bind(this);
    this.reorder = this.reorder.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.handleExtraItemToggle = this.handleExtraItemToggle.bind(this);
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.item?._id;
    const currentId = this.props.item?._id;
    if (currentId !== prevId) {
      const { item = {} } = this.props,
        {
          name = "",
          _id = "",
          description = "",
          minimum_number = 0,
          isRequired = false,
          maximum_number = 1,
          group_selections = [],
          store,
          brand,
        } = item;

      const formattedGroupSelections = (group_selections || []).map(
        (entry, idx) => ({
          _id:
            entry._id ||
            entry.extra_id?._id ||
            `extra_existing_${idx}_${Date.now()}`,
          ...entry,
          extra_id: {
            name: "",
            price: "",
            available: true,
            ...(entry.extra_id || {}),
          },
        }),
      );

      this.setState({
        values: {
          name,
          _id,
          minimum_number,
          maximum_number,
          isRequired,
          store,
          brand,
          description,
        },
        errors: {},
        touched: {},
        isSubmitting: false,
        group_selections: formattedGroupSelections,
      });
    }
  }

  handleOnClickCancelBtn = () => {
    if (this.props.onClickCancelBtn) {
      this.props.onClickCancelBtn();
    } else if (this.props.onHide) {
      this.props.onHide();
    }
  };

  onClickExtraDelete = () => {
    const extra_group_id = this.state.values._id;
    this.props.onClickExtraDelete &&
      this.props.onClickExtraDelete(extra_group_id);
  };

  handleOnBlurCategory = () => {
    this.setStateKey("touched", "category", "true");
    this.validateForm();
  };

  handleOnChange = (event) => {
    const target = event.target,
      value = target.value,
      name = target.name;

    let { values } = this.state;

    if (value !== "" && value.length > ITEM_DESCRIPTION_CHAR_LIMIT) {
      // do nothing
    } else {
      values[name] = value;
      if (name === "minimum_number") {
        values[name] = Number(value);
        if (Number(value) > 0) {
          values["isRequired"] = true;
        } else {
          values["isRequired"] = false;
        }
      }
      if (name === "maximum_number") {
        values[name] = Number(value);
      }
      if (name === "isRequired") {
        if (target.checked === false) {
          values["minimum_number"] = 0;
          values["isRequired"] = false;
        } else {
          values["minimum_number"] = 1;
          values["isRequired"] = true;
        }
      }
      this.setState({
        values: values,
      });
    }

    this.setStateKey("touched", name, "true");
    this.validateForm();

    // checks if afterOnChange function exists
    this.onChange && this.onChange(event);
  };

  handleFormValidation = () => {
    let { errors = {}, values = {}, group_selections } = this.state;

    const { required = [] } = this.validate;

    for (var r in required) {
      const name = required[r],
        value = values[name];
      if (name === "maximum_number") {
        if (Number(value) <= 0) {
          errors[name] = "This field requires 1 or more value";
        } else if (
          Number(value) !== 1 &&
          Number(value) < this.state.values.minimum_number
        ) {
          errors[name] = "Value should be greater than the minimum number";
        } else if (
          this.state.group_selections.length !== 0 &&
          Number(value) > this.state.group_selections.length
        ) {
          errors[name] = "Invalid value (cannot exceed total extras)";
        } else if (value === "" && this.isTouched(name)) {
          errors[name] = "This field is required";
        } else {
          delete errors[name];
        }
      } else if (name === "minimum_number") {
        if (Number(value) < 0) {
          errors[name] = "This field requires 0 or more value";
        } else if (
          Number(value) !== 0 &&
          Number(value) > this.state.values.maximum_number
        ) {
          errors[name] = "Value should be less than the maximum number";
        } else if (value === "" && this.isTouched(name)) {
          errors[name] = "This field is required";
        } else {
          delete errors[name];
        }
      } else {
        if (value === "" && this.isTouched(name)) {
          errors[name] = "This field is required";
        } else if (errors[name] === "This field is required") {
          delete errors[name];
        } else if (errors[name] === "This field required 1 or more value") {
          delete errors[name];
        }
      }
    }
    // Clean up any stale extra item error keys that exceed current group_selections length
    Object.keys(errors).forEach((key) => {
      const match = key.match(/^(?:name|price)_f_(\d+)$/);
      if (match && Number(match[1]) >= group_selections.length) {
        delete errors[key];
      }
    });

    for (var i in group_selections) {
      const val = group_selections[i]["extra_id"] || {},
        target_price = `price_f_${i}`,
        target_name = `name_f_${i}`;
      if (val["price"] === "" || val["price"] === undefined) {
        errors[target_price] = "Price is required";
      } else {
        delete errors[target_price];
      }

      if (val["name"] === "" || val["name"] === undefined) {
        errors[target_name] = "Name is required";
      } else {
        delete errors[target_name];
      }
    }
    return errors;
  };

  onChange = (event) => {
    const target = event.target,
      checked = target.checked,
      name = target.name;
    let { values = {} } = this.state,
      state = {};

    if (name === "isRequired") {
      values[name] = checked;
      state.values = values;
    }
    this.setState(state);
  };

  setAllFieldsToTouched = async () => {
    const keys = this.getFields();
    let params = { ...this.state.touched };
    for (var key in keys) params[keys[key]] = true;
    (this.state.group_selections || []).forEach((_, idx) => {
      params[`name_f_${idx}`] = true;
      params[`price_f_${idx}`] = true;
    });
    this.setState({ touched: params });
  };

  async handleOnSubmit(event) {
    event.preventDefault();
    await this.setAllFieldsToTouched();

    if (this.isFormOk()) {
      const {
        group_selections,
        values: { minimum_number },
      } = this.state;
      const available_extras = group_selections.filter(({ extra_id = {} }) => {
        return (
          extra_id.available ||
          isUndefined(extra_id.available) ||
          isNull(extra_id.available)
        );
      });
      if (group_selections.length === 0) {
        MySwal.fire({
          icon: "error",
          title: "Ooops!",
          text: "You need to have at least one Extra on your list to create an Extras Group",
          confirmButtonColor: DANGER_COLOR,
          confirmButtonText: "Okay",
        });
      } else if (group_selections.length < minimum_number) {
        MySwal.fire({
          icon: "error",
          title: "Ooops!",
          text: "Number of extras on your list is below the assigned minimum number. Please add more extras to proceed.",
          confirmButtonColor: DANGER_COLOR,
          confirmButtonText: "Okay",
        });
      } else if (available_extras.length < minimum_number) {
        MySwal.fire({
          icon: "error",
          title: "Ooops!",
          text: "Number of available extras on your list is below the assigned minimum number. Please add more extras to proceed.",
          confirmButtonColor: DANGER_COLOR,
          confirmButtonText: "Okay",
        });
      } else {
        this.setSubmitting();
        this.onSubmit &&
          this.onSubmit(
            this.state.values,
            this.setSubmitting,
            this.state.group_selections,
            this.state,
          );
      }
    }
  }

  onSubmit = (values, setSubmitting, group_selections) => {
    const payloadValues = { ...values };
    delete payloadValues["_id"];
    const extra_group_val = {
      ...payloadValues,
      group_selections: group_selections,
    };

    this.props.onSubmit(extra_group_val, setSubmitting);
  };

  afterSubmit = () => {
    this.props.afterSubmit && this.props.afterSubmit();
  };

  addClick() {
    const newId = `extra_temp_${Date.now()}_${Math.random()
      .toString(36)
      .substring(2, 8)}`;
    this.setState(
      (prevState) => ({
        group_selections: [
          ...prevState.group_selections,
          {
            _id: newId,
            extra_id: { name: "", price: "", available: true, _id: "" },
          },
        ],
      }),
      () => {
        this.validateForm();
      },
    );
  }

  removeClick(i) {
    let group_selections = [...this.state.group_selections];
    group_selections.splice(i, 1);
    let { errors = {}, touched = {} } = this.state;
    // Clean up all extra item errors and touched states; they will be re-evaluated
    Object.keys(errors).forEach((key) => {
      if (/^(?:name|price)_f_\d+$/.test(key)) {
        delete errors[key];
      }
    });
    const newTouched = { ...touched };
    Object.keys(newTouched).forEach((key) => {
      if (/^(?:name|price)_f_\d+$/.test(key)) {
        delete newTouched[key];
      }
    });
    this.setState({ group_selections, errors, touched: newTouched }, () => {
      this.validateForm();
    });
  }

  handleExtrasChange(i, event) {
    const target = event.target,
      value = target.value,
      name = target.name;

    let group_selections = [...this.state.group_selections];
    if (group_selections[i] && group_selections[i]["extra_id"]) {
      group_selections[i]["extra_id"][name] = value;
    }

    this.setStateKey("touched", `${name}_f_${i}`, "true");
    this.validateForm();

    this.setState({ group_selections });
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result.map((extra, i) => {
      return { ...extra, position: i };
    });
  };

  onDragEnd = (result) => {
    const { group_selections } = this.state;
    const { source, destination } = result;

    if (!destination) {
      return;
    }
    if (source.index === destination.index) {
      return;
    }

    const items = this.reorder(
      group_selections,
      source.index,
      destination.index,
    );

    this.setState({ group_selections: items });
  };

  handleExtraItemToggle = (isChecked, idx) => {
    const { group_selections } = this.state;
    const group_copy = group_selections.map((item, i) => {
      if (i === idx) {
        return {
          ...item,
          extra_id: {
            ...item.extra_id,
            available: isChecked,
          },
        };
      }
      return item;
    });

    this.setState({ group_selections: group_copy });
  };

  ExtrasUI() {
    const actions = {
      handleFeedbackError: this.handleFeedbackError,
      isTouched: this.isTouched,
    };

    if (this.state.group_selections.length === 0) {
      return (
        <div className="text-center py-10 px-4 my-2 border border-dashed rounded-lg bg-white">
          <div className="symbol symbol-50 symbol-circle symbol-light-primary mb-3">
            <span className="symbol-label">
              <i className="flaticon2-plus text-primary font-size-h4"></i>
            </span>
          </div>
          <h6 className="font-weight-bolder text-dark mb-1">
            No extras added yet
          </h6>
          <p className="text-muted font-size-sm mb-4">
            Add options that your customers can select from (e.g. Extra Cheese,
            Extra Sauce)
          </p>
          <Button
            variant="primary"
            size="sm"
            className="font-weight-bolder px-5"
            onClick={() => this.addClick()}
          >
            <i className="ki ki-plus icon-sm mr-1"></i> Add First Extra
          </Button>
        </div>
      );
    }

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId={"extraitems"} type="EXTRAITEM">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className="extras-droppable-list"
            >
              {this.state.group_selections.map(({ _id, extra_id = {} }, i) => {
                const isAvailable = extra_id.available !== false;
                const dragId = String(_id || extra_id._id || `extra_item_${i}`);
                const nameFieldName = `name_f_${i}`;
                const priceFieldName = `price_f_${i}`;
                const nameError = this.handleFeedbackError(
                  nameFieldName,
                  "error-text",
                );
                const priceError = this.handleFeedbackError(
                  priceFieldName,
                  "error-text",
                );
                const isNameTouched = this.isTouched(nameFieldName);
                const isPriceTouched = this.isTouched(priceFieldName);
                const hasRowError =
                  (isNameTouched && !!nameError) ||
                  (isPriceTouched && !!priceError);

                return (
                  <Draggable
                    key={dragId}
                    draggableId={dragId}
                    index={i}
                    type="EXTRAITEM"
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`extra-item-card mb-2 rounded bg-white border ${
                          snapshot.isDragging
                            ? "shadow-lg border-primary"
                            : hasRowError
                            ? "border-danger shadow-xs"
                            : "border-light-dark shadow-xs"
                        }`}
                        style={{
                          transition:
                            "box-shadow 0.15s ease, border-color 0.15s ease",
                          ...provided.draggableProps.style,
                        }}
                      >
                        <div className="d-flex align-items-start p-2 px-3">
                          {/* Drag handle */}
                          <div
                            {...provided.dragHandleProps}
                            className="extra-drag-handle mr-2 text-muted px-1"
                            title="Drag to reorder"
                            style={{
                              height: "38px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <i className="fas fa-grip-vertical text-hover-primary"></i>
                          </div>

                          {/* Availability toggle */}
                          <div
                            className="d-flex align-items-center mr-3 flex-shrink-0"
                            style={{ minWidth: "105px", height: "38px" }}
                          >
                            <span
                              className="switch switch-sm switch-outline switch-icon switch-primary mr-2"
                              title={
                                isAvailable
                                  ? "Click to mark as unavailable"
                                  : "Click to mark as available"
                              }
                            >
                              <label className="mb-0">
                                <input
                                  type="checkbox"
                                  checked={isAvailable}
                                  onChange={(e) =>
                                    this.handleExtraItemToggle(
                                      e.target.checked,
                                      i,
                                    )
                                  }
                                />
                                <span></span>
                              </label>
                            </span>
                            <span
                              className={`font-size-xs font-weight-bold ${
                                isAvailable ? "text-success" : "text-muted"
                              }`}
                            >
                              {isAvailable ? "Available" : "Hidden"}
                            </span>
                          </div>

                          {/* Extra Name Input */}
                          <div className="flex-grow-1 mr-2">
                            <FormItem
                              name={nameFieldName}
                              noLabel
                              placeholder="Option name (e.g. Extra Cheese)"
                              inputProps={{
                                name: "name",
                                placeholder: "Option name (e.g. Extra Cheese)",
                                value: extra_id.name || "",
                              }}
                              inputActions={{
                                onChange: this.handleExtrasChange.bind(this, i),
                              }}
                              actions={actions}
                              type={"text"}
                              normal
                              style={{ marginBottom: 0 }}
                            />
                          </div>

                          {/* Price Input with currency prefix */}
                          <div
                            className="mr-2"
                            style={{ width: "140px", minWidth: "140px" }}
                          >
                            <FormItem
                              name={priceFieldName}
                              noLabel
                              placeholder="0.00"
                              prepend={
                                <div className="input-group-prepend">
                                  <span className="input-group-text font-weight-bolder font-size-xs py-0 px-2 bg-light">
                                    ₱
                                  </span>
                                </div>
                              }
                              inputProps={{
                                name: "price",
                                placeholder: "0.00",
                                min: 0,
                                step: "any",
                                value:
                                  extra_id.price !== undefined
                                    ? extra_id.price
                                    : "",
                              }}
                              inputActions={{
                                onChange: this.handleExtrasChange.bind(this, i),
                              }}
                              actions={actions}
                              type={"number"}
                              normal
                              style={{ marginBottom: 0 }}
                            />
                          </div>

                          {/* Delete Item */}
                          <div
                            style={{
                              height: "38px",
                              display: "flex",
                              alignItems: "center",
                            }}
                            className="flex-shrink-0"
                          >
                            <button
                              type="button"
                              className="btn btn-icon btn-xs btn-light-danger"
                              title="Remove extra option"
                              onClick={() => this.removeClick(i)}
                            >
                              <i className="ki ki-close icon-xs"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }

  render() {
    const actions = {
        handleFeedbackError: this.handleFeedbackError,
        isTouched: this.isTouched,
      },
      inputActions = {
        onChange: this.handleOnChange,
        onBlur: this.handleOnBlur,
      };

    const { values, group_selections, isSubmitting } = this.state;
    const isEdit = values._id !== "";

    return (
      <Form
        className="fv-plugins-bootstrap fv-plugins-framework extra-modal-form"
        onSubmit={this.handleOnSubmit}
      >
        <style>{`
          .extra-modal-form {
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;
          }
          .extra-modal-body-scroll {
            flex: 1 1 auto;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 1.25rem 1.5rem;
          }
          .extras-list-container {
            max-height: calc(100vh - 380px);
            min-height: 220px;
            overflow-y: auto;
            overflow-x: hidden;
            padding-right: 4px;
          }
          @media (max-height: 800px) {
            .extras-list-container {
              max-height: calc(100vh - 320px);
              min-height: 180px;
            }
          }
          .extra-drag-handle {
            cursor: grab;
          }
          .extra-drag-handle:active {
            cursor: grabbing;
          }
          .extras-list-container::-webkit-scrollbar {
            width: 6px;
          }
          .extras-list-container::-webkit-scrollbar-track {
            background: transparent;
          }
          .extras-list-container::-webkit-scrollbar-thumb {
            background: #d4dadf;
            border-radius: 4px;
          }
          .extras-list-container::-webkit-scrollbar-thumb:hover {
            background: #b5b5c3;
          }
          .extra-item-card .form-group {
            margin-bottom: 0 !important;
          }
          .extra-item-card .fv-plugins-message-container {
            margin-top: 3px !important;
            margin-bottom: 0 !important;
          }
          .extra-item-card .fv-plugins-message-container .fv-help-block {
            font-size: 0.75rem !important;
            font-weight: 500 !important;
            color: #f64e60 !important;
            line-height: 1.2 !important;
            margin-top: 2px !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }
        `}</style>

        <div className="extra-modal-body-scroll">
          <Row>
            {/* Left Column: Group Details & Selection Rules */}
            <Col lg={5} className="mb-4 mb-lg-0">
              {/* Group Details Card */}
              <div className="card card-custom border bg-white mb-4">
                <div className="card-header py-3 px-4 border-bottom min-h-auto">
                  <div className="card-title my-0">
                    <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0">
                      Group Details
                    </h5>
                  </div>
                </div>
                <div className="card-body p-4">
                  <FormItem
                    label={"Group Name"}
                    name={"name"}
                    inputProps={{
                      name: "name",
                      placeholder: "e.g. Choose Your Sauce",
                      value: values["name"],
                    }}
                    inputActions={inputActions}
                    actions={actions}
                    type={"text"}
                    showRequired={true}
                    normal
                  />
                  <FormItem
                    label={"Description"}
                    name={"description"}
                    inputProps={{
                      name: "description",
                      placeholder: "e.g. Select up to 2 sauces for your meal",
                      value: values["description"],
                    }}
                    inputActions={inputActions}
                    actions={actions}
                    type={"text"}
                    showRequired={true}
                    normal
                  />
                </div>
              </div>

              {/* Selection Rules Card */}
              <div className="card card-custom border bg-white">
                <div className="card-header py-3 px-4 border-bottom min-h-auto">
                  <div className="card-title my-0">
                    <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0">
                      Selection Rules
                    </h5>
                  </div>
                </div>
                <div className="card-body p-4">
                  {/* Required Switch */}
                  <div className="d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
                    <div>
                      <label className="font-weight-bolder text-dark mb-0 d-block">
                        Required Selection
                      </label>
                      <span className="text-muted font-size-xs">
                        Customer must pick from this group
                      </span>
                    </div>
                    <span className="switch switch-outline switch-icon switch-primary">
                      <label className="mb-0">
                        <input
                          type="checkbox"
                          name="isRequired"
                          checked={values.isRequired ? true : false}
                          onChange={this.handleOnChange}
                        />
                        <span></span>
                      </label>
                    </span>
                  </div>

                  {/* Min and Max in 2 columns */}
                  <Row>
                    <Col sm={6}>
                      <FormItem
                        label={"Min Selections"}
                        name={"minimum_number"}
                        inputProps={{
                          name: "minimum_number",
                          placeholder: "0",
                          value: values["minimum_number"],
                          min: 0,
                        }}
                        inputActions={inputActions}
                        actions={actions}
                        type={"number"}
                        showRequired={true}
                        normal
                        helperText={
                          <span className="text-muted font-size-xs">
                            Set <b>0</b> for optional
                          </span>
                        }
                      />
                    </Col>
                    <Col sm={6}>
                      <FormItem
                        label={"Max Selections"}
                        name={"maximum_number"}
                        inputProps={{
                          name: "maximum_number",
                          placeholder: "1",
                          value: values["maximum_number"],
                          min: 1,
                        }}
                        inputActions={inputActions}
                        actions={actions}
                        type={"number"}
                        showRequired={true}
                        normal
                        helperText={
                          <span className="text-muted font-size-xs">
                            Max customer can choose
                          </span>
                        }
                      />
                    </Col>
                  </Row>

                  {/* Rule summary indicator */}
                  <div className="p-3 rounded bg-light-primary border border-primary-o-30 mt-1 d-flex align-items-center">
                    <i className="flaticon2-information text-primary mr-2 font-size-base"></i>
                    <span className="font-size-xs text-dark-75">
                      {values.minimum_number > 0 ? (
                        <>
                          Customer must choose between{" "}
                          <b>{values.minimum_number}</b> and{" "}
                          <b>{values.maximum_number}</b>{" "}
                          {values.maximum_number === 1 ? "option" : "options"}.
                        </>
                      ) : (
                        <>
                          Optional: Customer can choose up to{" "}
                          <b>{values.maximum_number}</b>{" "}
                          {values.maximum_number === 1 ? "option" : "options"}.
                        </>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Col>

            {/* Right Column: Extras Options */}
            <Col lg={7}>
              <div className="card card-custom border bg-white h-100 d-flex flex-column">
                <div className="card-header py-3 px-4 border-bottom min-h-auto d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0 mr-2">
                      Extras Options
                    </h5>
                    <span className="badge badge-light-primary font-weight-bolder">
                      {group_selections.length}{" "}
                      {group_selections.length === 1 ? "item" : "items"}
                    </span>
                  </div>
                  <Button
                    variant="primary"
                    size="sm"
                    className="font-weight-bolder py-1 px-3"
                    onClick={() => this.addClick()}
                  >
                    <i className="ki ki-plus icon-xs mr-1"></i> Add Extra
                  </Button>
                </div>
                <div className="card-body p-4 d-flex flex-column flex-grow-1">
                  <InfoAlertHelper text="Drag items with the handle to arrange their display order on your store." />
                  <div className="extras-list-container flex-grow-1 mt-2">
                    {this.ExtrasUI()}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* Sticky Action Footer */}
        <div className="extra-modal-footer bg-white border-top px-6 py-3 d-flex justify-content-between align-items-center">
          <div>
            {this.props.showDeleteButton ? (
              <button
                type="button"
                disabled={this.props.deleteLoading}
                className={GetSubmitClassList(
                  this.props.deleteLoading,
                  "btn btn-light-danger font-weight-bold px-5 py-2",
                )}
                onClick={this.onClickExtraDelete}
              >
                <i className="ki ki-bold-trash icon-sm mr-1"></i>
                <span>Delete</span>
              </button>
            ) : null}
          </div>
          <div className="d-flex align-items-center">
            <button
              type="button"
              disabled={isSubmitting}
              className="btn btn-light-dark font-weight-bold px-6 py-2 mr-3"
              onClick={this.handleOnClickCancelBtn}
            >
              <span>Cancel</span>
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className={GetSubmitClassList(
                isSubmitting,
                "btn btn-primary font-weight-bold px-7 py-2",
              )}
            >
              <span>{isEdit ? "Save Changes" : "Create Extras Group"}</span>
            </button>
          </div>
        </div>
      </Form>
    );
  }
}
